import { Grid } from '@mui/material'
import { LabeledText } from '../../../components'
import { BankAccount } from '../../../utils/classes/graphql'
import { MembershipFeesQueryType } from '../../../types/types'
import { filterValidObligations } from '../../../hooks/user-data/utils'
import { formatAccrualBaseAmount } from '../utils'

interface PaymentInfoProps {
  membershipFees: MembershipFeesQueryType
}

export const PaymentInfo = ({ membershipFees }: PaymentInfoProps) => {
  const { bankAccounts, accrualBasesThisYear, membershipFeeObligations } =
    membershipFees

  const accountNamesAndNumbers = bankAccounts.map((item: BankAccount) => {
    return item.konttori + ' ' + item.iban
  })

  const accrualBaseAmount = accrualBasesThisYear?.[0]
    ? formatAccrualBaseAmount(accrualBasesThisYear?.[0])
    : '-'

  const paymentMethod = filterValidObligations(membershipFeeObligations)

  return (
    <Grid container spacing={{ md: 2 }}>
      <Grid item md={4} xs={12}>
        <LabeledText
          labelTranslationId="pages.membershipFeesPage.paymentInformation.paymentBasis"
          texts={[accrualBaseAmount]}
        />
      </Grid>
      <Grid item md={true} xs={12}>
        <LabeledText
          labelTranslationId="pages.membershipFeesPage.paymentInformation.paymentRecipient"
          textTranslationIds={['contact.address.postName']}
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <LabeledText
          labelTranslationId="pages.membershipFeesPage.paymentInformation.accountNumbers"
          texts={accountNamesAndNumbers}
          defaultText="-"
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <LabeledText
          labelTranslationId="pages.membershipFeesPage.paymentInformation.paymentMethod"
          textTranslationIds={[paymentMethod]}
        />
      </Grid>
    </Grid>
  )
}
